import GavelIcon from '@mui/icons-material/Gavel';
import LanIcon from '@mui/icons-material/Lan';
import QueryStatsIcon from '@mui/icons-material/QueryStats';
import TableViewIcon from '@mui/icons-material/TableView';
import { SvgIconTypeMap } from '@mui/material';
import { OverridableComponent } from '@mui/material/OverridableComponent';

type IconType = OverridableComponent<SvgIconTypeMap<{}, 'svg'>> & {
  muiName: string;
};

export type MenuType = {
  label: string;
  path: string;
  icon: IconType;
};

const menuItems: MenuType[] = [
  {
    label: 'Standings',
    path: '/',
    icon: LanIcon,
  },
  {
    label: 'My Picks',
    path: '/picks',
    icon: TableViewIcon,
  },
  {
    label: 'Results',
    path: '/results',
    icon: QueryStatsIcon,
  },
  {
    label: 'Rules',
    path: '/rules',
    icon: GavelIcon,
  },
];

export default menuItems;
